<template>
  <div id="page-opportunity" class="page">
    <div class="container">
      <section>
        <header class="header">
          <p>
            <span>全场景</span>
            <span>全类目</span>
            <span>全时段</span>
          </p>
          <p class="subtitle">
            <span>scenel</span>
            <span>category</span>
            <span>time interval</span>
          </p>
        </header>
        <div class="scene-pics">
          <div class="middle-big">
            <img src="/static/opportunity-scene44.png"/>
          </div>
        </div>
      </section>
      <section>
        <header class="header">等候区</header>
        <p class="subtitle">Waiting area</p>
        <div class="scene-pics">
          <div class="left">
            <img class="top" src="/static/opportunity-scene21.png"/>
          </div>
          <div class="middle">
            <img class="top" src="/static/opportunity-scene22.png"/>
            <img src="/static/opportunity-scene23.png"/>
          </div>
          <div class="right">
            <img src="/static/opportunity-scene24.png"/>
          </div>
        </div>
      </section>
      <section>
        <header class="header">餐饮升级</header>
        <p class="subtitle">Food and beverage upgrading</p>
        <div class="scene-pics">
          <div class="left">
            <img class="top" src="/static/opportunity-scene31.png"/>
            <img class="top" src="/static/opportunity-scene32.png"/>
          </div>
          <div class="middle">
            <img class="top" src="/static/opportunity-scene33.png"/>
            <img src="/static/opportunity-scene34.png"/>
          </div>
          <div class="right">
            <img class="top" src="/static/opportunity-scene35.png"/>
            <img src="/static/opportunity-scene36.png"/>
          </div>
        </div>
      </section>
      <section>
        <header class="header">更多场景</header>
        <p class="subtitle">More scenes</p>
        <div class="scene-pics more">
          <div class="left">
            <img src="/static/opportunity-scene41.png"/>
          </div>
          <div class="middle">
            <img src="/static/opportunity-scene42.png"/>
          </div>
          <div class="right">
            <img src="/static/opportunity-scene43.png"/>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'opportunity',
  data () {
    return {
      msg: ''
    }
  },
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#page-opportunity {
  height: 100%;
  .container {
    height: 100%;
    .header {
      margin-top: 60px;
      font-size: 32px;
      color: #333333;
      p {
        padding: 0;
        margin: 0;
      }
      span {
        margin-top:-40px;
        /*margin-left: 9%;*/
        padding: 0 40px;
      }
    }
    .subtitle {
      margin: 0;
      margin-bottom: 40px;
      font-size: 14px;
      color: #888888;
      span {
        margin-right: 4px;
        display: inline-block;
        text-align: center;
        width: 176px;
        height: 40px;
      }
    }

    .scene-pics {
      display: flex;
      height: 360px;
    }

    .scene-pics img {
      max-width: 100%;
      vertical-align: top;
    }

    .scene-pics .left{
      flex: 36;
      margin-right: 20px;
    }
    .scene-pics .middle{
      flex: 49;
    }
    .scene-pics .middle-big {
      width: 100%;
      img {
        width: 100%;
        height: 360px;
        /*margin-bottom: 10%;*/
      }
    }
    .scene-pics .right{
      margin-left: 20px;
      flex: 36;
    }
    .scene-pics .top {
      margin-bottom: 20px;
    }

    .scene-pics.more .left{
      flex: 41;
    }
    .scene-pics.more .middle{
      flex: 42;
    }
    .scene-pics.more .right{
      flex: 41;
    }
  }
  @media only screen and (max-width: 1700px) and (min-width: 0px) {
    .scene-pics .middle .top, .scene-pics.more .middle{
      margin-top: 16px;
      background-color: red;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Opportunity.vue